import { ACTION_CONSTANTS } from 'actions/constants';

const INITIAL_STATE = {
  currentUserId: null
};

export function sessionSettings(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTION_CONSTANTS.sessionSettings.setSessionSettings:
      let newState = JSON.parse(JSON.stringify(state));
      const target = action.payload.path[action.payload.path.length - 1];
      let currentDir = newState;
      action.payload.path.forEach((dir, i) => {
        if (i !== action.payload.path.length - 1) {
          currentDir = currentDir[dir];
        }
      });
      currentDir[target] = action.payload.data;
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessionSettings.js